﻿const filters = {
    $listFilter: $('.js-list-filter'),
    listFilters: [],
    init: function () {
        $(document).ready(() => {
            this.$listFilter.map((index, list) => {
                let $list = $(list);
                this.listFilters.push({
                    $list,
                    $listClone: $list.clone(true, true)
                });
            });

            if (this.$listFilter.length > 0) {
                $('select.js-filter').on('change', () => {
                    this.filterItems($('select.js-filter').val(), $('.search-term').val().trim());
                });
                $('.trigger-search').on('click', () => {
                    this.filterItems($('select.js-filter').val(), $('.search-term').val().trim());
                });
                $('.search-term').on('change', () => {
                    this.filterItems($('select.js-filter').val(), $('.search-term').val().trim());
                });
            }
        })
    },
    filterItems: function (filter, searchTerm) {
        // Show all sections
        $('.filter-section').show();

        // Show/hide matching items
        this.listFilters.map(list => {
            list.$list.empty();

            // We need to clone items, otherwise carousel would remove items mathing current filter wehn filter is cleared
            const itemsClone = list.$listClone.clone(true, true);
            let items = itemsClone.children().filter(function (index) {
                return (!filter || $(this).attr('data-filter') == filter)
                    && (!searchTerm || $(this).attr('data-search').toLowerCase().includes(searchTerm.toLowerCase()));
            });

            list.$list.append(items);
        });

        // Hide empty sections
        if ($('.js-list-filter').find('.cell').length == 0) {
            $('.filter-section').hide();
        }

        // Show no results section if there is no content
        if ($('.filter-section:visible').length > 0) {
            $('.no-results-wrapper').hide();
        }
        else {
            $('.no-results-wrapper').show();
            $('.no-results-wrapper #search-term').text(searchTerm);
        }

        // Trigger resize event to update positions when content is hidden/shown
        $(window).trigger('resize');
    }
}

filters.init();
